export default __webpack_public_path__ + "static/mario-3a442983ab6c8e40ac205c7baacb4381.png";